module.exports = __webpack_public_path__ + "static/media/after-interview.1a52d761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/after-interview/after-interview.png
// module id = 38
// module chunks = 0